import plugins from './plugins';
import themes from './theme';

export default {
  themes,
  plugins,
};
